// src/pages/DashboardProject/CreateJobButton.tsx
import React, { useState } from 'react';
import { Button } from 'reactstrap';
import CustomerCreateJobModal from './CustomerCreateJobModal';
import { FilePlus } from 'lucide-react';

// Define props interface and export it
export interface CreateJobButtonProps {
  className?: string;
  variant?: 'primary' | 'info' | 'secondary';
  onJobCreated?: () => void;
}

// Define component using the props interface
const CreateJobButton: React.FC<CreateJobButtonProps> = ({
  className = '',
  variant = 'primary',
  onJobCreated
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleJobCreated = () => {
    if (onJobCreated) {
      onJobCreated();
    }
    toggleModal();
  };

  return (
    <>
      <Button
        color={variant}
        onClick={toggleModal}
        className={className}
      >
        <FilePlus /> Create Job
      </Button>

      <CustomerCreateJobModal
        isOpen={modalOpen}
        toggle={toggleModal}
        onJobCreated={handleJobCreated}
      />
    </>
  );
};

// Export the component as default
export default CreateJobButton;